/* ********************* *
* Create the default map *
* ********************** */
function createMap () {

    var latLng = new google.maps.LatLng(55.3617609, -3.4433238); // Default LatLng (UK)
    var maxZoom = 16; // Default max zoom
    var zoom = 10; // Default zoom

    var styles = [
        {
            stylers: [
                { hue: '#c22236' }
            ]
        }, {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
                { lightness: 100 },
                { visibility: 'simplified' }
            ]
        }
    ];

    var mapOptions = {
        center: latLng,
        maxZoom: maxZoom,
        zoom: zoom,
        /*styles: styles,*/

        disableDefaultUI: true,
        zoomControl: true
    };

    return new google.maps.Map($('#map-canvas')[0], mapOptions);

}

/* ***************************** *
* Create the default info window *
* ****************************** */
function createInfoWindow() {
    return new google.maps.InfoWindow({
        content: '',
        maxWidth: 250
    });
}

/* ********* *
* Add marker *
* ********** */
function addMarker(map, infoWindow, latLng, htmlContent, markerTitle) {

    var marker = new google.maps.Marker({
        map: map,
        position: latLng,
        icon: '/images/map-marker.png',
        animation: google.maps.Animation.DROP,
        title: markerTitle
    });

    if (infoWindow != null) {
        (function (marker, map, htmlContent) {
            google.maps.event.addListener(marker, 'click', function () {
                infoWindow.setContent(htmlContent);
                infoWindow.open(map, marker);
                addClassesToPopUpWindow();
                var panLatLng = offsetLatLng(map, marker.getPosition(), 0, -150);
                map.panTo(panLatLng);
            });
        })(marker, map, htmlContent);
    }

    return marker;
};

/* ****************************************************** *
* Moves the map to the position of the opened info window *
* ******************************************************* */
function offsetLatLng(map, latlng, offsetx, offsety) {

    var point1 = map.getProjection().fromLatLngToPoint(
        (latlng instanceof google.maps.LatLng) ? latlng : map.getCenter()
    );

    var point2 = new google.maps.Point(
        ((typeof (offsetx) == 'number' ? offsetx : 0) / Math.pow(2, map.getZoom())) || 0,
        ((typeof (offsety) == 'number' ? offsety : 0) / Math.pow(2, map.getZoom())) || 0
    );

    return map.getProjection().fromPointToLatLng(new google.maps.Point(
        point1.x - point2.x,
        point1.y + point2.y
    ));

};

/* ************** *
* Draw directions *
* *************** */
function drawDirections(map, origin, destination) {

    var directionsDisplay = new google.maps.DirectionsRenderer();
    var directionsService = new google.maps.DirectionsService();

    var targets = new Array();

    var request = {
        origin: origin,
        destination: destination,
        travelMode: google.maps.TravelMode.DRIVING
    };

    directionsDisplay.setMap(map);

    directionsService.route(request, function (response, status) {
        directionsDisplay.setDirections(response);
    });

}

/* ********************* *
* Initialise RESULTS MAP *
* ********************** */
function initResultsMap() {

    var map = createMap();

    var infoWindow = createInfoWindow();

    var bounds = new google.maps.LatLngBounds();

    var marker = null;

    // Fetch the properties
    $('*[data-object=property]').each(function () {
        // Build a market for this property
        var $property = $(this);
        var latitude = parseFloat($property.data('latitude'));
        var longitude = parseFloat($property.data('longitude'));
        var propertyLink = $property.data('property-link');
        var propertyImage = $property.data('property-image');
        var propertyAddress = $property.data('property-address');
        
        var htmlContent = buildPopUpWindowHtml(null, propertyLink, propertyImage, null, null, propertyAddress, null);
        marker = addMarker(map, infoWindow, new google.maps.LatLng(latitude, longitude), htmlContent, propertyAddress);

        bounds.extend(marker.getPosition());
    });

    map.fitBounds(bounds);

}

/* ********************** *
* Initialise PROPERTY MAP *
* *********************** */
function initPropertyMap() {

    var map = createMap();

    var bounds = new google.maps.LatLngBounds();

    var marker = null;

    // Fetch the properties
    $('*[data-object=property]').each(function () {
        // Build a market for this property
        var $property = $(this);

        var latitude = parseFloat($property.data('latitude'));
        var longitude = parseFloat($property.data('longitude'));

        var propertyAddress = $property.data('property-address');

        marker = addMarker(map, null, new google.maps.LatLng(latitude, longitude), null, propertyAddress);

        bounds.extend(marker.getPosition());
    });

    map.fitBounds(bounds);

    // Check for directions start point
    var $startPoint = $('*[data-object=start-point]');
    if ($startPoint.size() > 0) {
        var latitude = parseFloat($startPoint.data('latitude'));
        var longitude = parseFloat($startPoint.data('longitude'));

        var origin = new google.maps.LatLng(latitude, longitude);
        var destination = marker.getPosition();

        marker.setMap(null);

        drawDirections(map, origin, destination);
    }

}

/* ********************** *
* Initialise Street View *
* *********************** */
function initPropertyStreetView() {

   var $property= $('*[data-object=property]');
   var latitude = parseFloat($property.data('latitude'));
   var longitude = parseFloat($property.data('longitude'));
   var propertyPosition = new google.maps.LatLng(latitude, longitude);
   var panoramaOptions = { position: propertyPosition,
       pov: { heading: 165, pitch: 0 },
       zoom: 1
   };
   var myPano = new google.maps.StreetViewPanorama(document.getElementById('streetview-canvas'), panoramaOptions);
   myPano.setVisible(true);

        
}